// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const venomoth: PokeData = {
  "id": 49,
  "name": "venomoth",
  "height": 15,
  "weight": 125,
  "base_experience": 158,
  "types": [
    PokeType.BUG,
    PokeType.POISON
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "tackle",
    "supersonic",
    "disable",
    "psybeam",
    "mega-drain",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "confusion",
    "psychic",
    "agility",
    "screech",
    "leech-life",
    "foresight",
    "poison-fang",
    "silver-wind",
    "signal-beam",
    "air-slash",
    "bug-buzz",
    "zen-headbutt",
    "quiver-dance",
    "struggle-bug"
  ],
  "moves": [
    "gust",
    "tackle",
    "supersonic",
    "poison-powder",
    "stun-spore",
    "psychic",
    "poison-fang",
    "air-slash",
    "bug-buzz",
    "zen-headbutt",
    "pin-missile",
    "leech-steal",
    "acid-rain"
  ],
  "evolution_chain": {
    "id": 20,
    "item": null,
    "species": [
      {
        "name": "venonat",
        "order": 53,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "venomoth",
        "order": 54,
        "types": [
          PokeType.BUG,
          PokeType.POISON
        ],
        "evolves_from_species_id": 48,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 145,
    "ability_power": 145
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
